export type GetAlphaCatalogueApiArg = {
  lang: string;
};

export type GetAlphaCatalogueApiResponse = {
  keys: Key[];
  property_name?: string;
  vehicle_type?: string;
}[];

export type Key = {
  categories: string[];
  const_key: string;
  const_key_old: string | null;
  labels: Label[];
  parent?: string | null;
  properties?: Property[];
  sort_priority?: number | null;
};

type Label = {
  label: string;
  label_short: string | null;
  language?: string | null;
  seo_label?: string | null;
};

type Property = {
  name: string;
  value: any;
};
